import React from 'react';

import {makeStyles} from '@mui/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../../../components/displaycard';


const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 345,
    },
}));

const options = [
    {
        title: 'Audit Export(s)',
        description: 'Configure audit exports',
        img: '/images/audit.png',
        route: '/system/configuration/audit',
    },
    {
        title: 'Authentication',
        description: 'Configure authentication, LDAP, SAML, and Okta',
        img: '/images/authentication.png',
        route: '/system/configuration/auth',
    },
    {
        title: 'Email',
        description: 'Review email logs and settings',
        img: '/images/email.png',
        route: '/system/configuration/email',
    },
    {
        title: 'Proxy',
        description: 'Configure an HTTP proxy',
        img: '/images/proxy.png',
        route: '/system/configuration/proxy',
    },
    {
        title: 'SNMP',
        description: 'Adjust SNMP settings and users',
        img: '/images/snmp.png',
        route: '/system/configuration/snmp',
    },
    {
        title: 'UI',
        description: 'Change UI messages and lookup URLs',
        img: '/images/ui.png',
        route: '/system/configuration/ui',
    },
    {
        title: 'VPN',
        description: 'Modify VPN settings',
        img: '/images/vpn.png',
        route: '/system/configuration/vpn',
    },
    {
        title: 'OpenText™ NDR Support',
        description: 'Modify OpenText™ NDR Support settings',
        img: '/images/support.png',
        route: '/system/configuration/support',
    },
    {
        title: 'Web Server',
        description: 'Manage web server settings',
        img: '/images/web.png',
        route: '/system/configuration/web',
    },
];

const Configuration = (props) => {
    const classes = useStyles();

    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {options.map((p, i) => {
                    return (
                        <Grid item xl={3} lg={4} key={`policies-zeek-${i}`}>
                            <DisplayCard {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default Configuration;
